import React, { useState, useEffect } from 'react';
import { Container, Row } from 'react-bootstrap';
import Navigation from '../../../Shared/Navigation/Navigation';
import Project from '../Project/Project';

const Projects = () => {
    const [projects, setProjects] = useState([])
    useEffect(() => {
        fetch('/fakedata.json')
            .then(res => res.json())
            .then(data => setProjects(data))

    }, [])
    return (
        <>
            <Navigation></Navigation>
            <Container>
                <Row className='g-4'>
                    {
                        projects.map(project => <Project key={project.id} project={project}></Project>)
                    }
                </Row>

            </Container>
        </>
    );
};

export default Projects;